import { ChangeDetectorRef, Component, Input, NgZone, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import { MapService } from 'src/app/services/map.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { UserService } from 'src/app/services/user.service';

interface modelosVersiones{
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-ver-dispositivo-datos',
  templateUrl: './ver-dispositivo-datos.component.html',
  styleUrls: ['./ver-dispositivo-datos.component.css']
})
export class VerDispositivoDatosComponent implements OnInit, OnChanges, OnDestroy{

  lat: number = 43.0081016;
  lng: number = -7.5561412;
  zoom: number = 14;
  addressData: any;

  etiqueta: string = "";
  descripcion: string = "";
  nSIM: string = "";
  nSerie: string = "";
  searchPlace: string = "";
  file: File | undefined
  imageUrl: string | ArrayBuffer | null = null;
  showImageErrorMessage: boolean = false;
  disabledCheckbox = false;
  version: number | undefined;
  establishmentData: any = []; //Información de los establecimientos y dispositivos
  errorMessage : string =""; //Mensaje de error
  deviceId: number = 0; //Id del dispositivo que está en la ruta
  disopositivoActual: any = []; //Dispositivos que estamos editando
  dev_img: string = ""; //Imagen del dispositivo
  dev_img_path: string = "";
  tokenSeguridad: string = "";
  numSerie: string = "";
  multitanque: boolean = false;
  usuarioEmail: string = "";
  displayedColumns: string[] = ['email', 'operaciones'];
  configuracionFinalizada: boolean = false;
  map: any; 
  marker: any;

  //AUTOCOMPLETE
  establecimientoError: boolean = false;
  showEstadoError: boolean = false;
  dispositivoCreado: boolean = false;
  tiempoEsperaRecarga: number = 60000;
  errorFinal: boolean = false;
  waitAfterSave: boolean = false;
  errorFinalMessage: boolean = false;

  modeloVersion: modelosVersiones[] = [
    {value: 'noImplementado-0', viewValue: 'Sin Implementar'}
  ];
  selectedVersion: string = "";

  selectedEstado: string = "";
  selectedEstablecimiento: string = "";

  clientesData: any = []
  selectedCliente: string = "";

  userData: any = [];

  //Subscriptions
  private establishmentSubscription: Subscription | undefined;
  private clientsSubscription: Subscription | undefined;
  private editarDispositivoSubscription: Subscription | undefined;

  @Input() userId: any;
  
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  constructor(private deviceService: DeviceService, private userDataService: UserDataService,
    private userService : UserService, private error429: Error429Service, private mapService: MapService,
    private cdr: ChangeDetectorRef, private route: ActivatedRoute){

    this.userData = this.userDataService.getUserData();
    this.route.params.subscribe(params => {
      this.deviceId = params['id'];
    });
  }

  ngOnInit(){
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userId'] && this.userId !== undefined) {
      this.establishmentSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
        next:resp =>{
          this.establishmentData = resp;
          //Dispositivo actual
          for(let i=0; i<this.establishmentData.length; i++){
            for(let j=0; j<this.establishmentData[i].devices.length; j++){
              if(this.establishmentData[i].devices[j].id == this.deviceId){
                //console.log(this.establishmentData[i]);
                this.selectedEstablecimiento = this.establishmentData[i].id;
                this.disopositivoActual = this.establishmentData[i].devices[j];
                this.lat = this.establishmentData[i].est_lat;
                this.lng = this.establishmentData[i].est_lng;
                this.selectedEstablecimiento = this.establishmentData[i].est_name;
                this.clientsSubscription = this.userService.getClient(this.disopositivoActual.dev_cliente_id).subscribe({
                  next:resp =>{
                    this.selectedCliente = resp[0].razon_social;
                  },error:err =>{
                    if (err.status == 429) {
                      this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
                      this.recargarPaginaDespuesDeTiempo();
                    } else {
                      this.errorMessage = err.error.message;
                    }
                  }, complete:()=>{}
                });
              }
            }
          }
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        },complete: () =>{
          this.mapService.loadMapScript(this.initMap.bind(this));

          //console.log(this.disopositivoActual);
          this.etiqueta = this.disopositivoActual.dev_label;
          this.descripcion = this.disopositivoActual.dev_description;
          this.tokenSeguridad = this.disopositivoActual.dev_token;
          this.numSerie = this.disopositivoActual.dev_serie;
          this.nSIM = this.disopositivoActual.dev_sim;
          this.version = this.disopositivoActual.dev_version;
          if(this.disopositivoActual.dev_status == 1){
            this.selectedEstado = "Activado";
          } else {
            this.selectedEstado = "Desactivado";
          }
          if (this.disopositivoActual.locked == 1){
            this.configuracionFinalizada = true;
          } else {
            this.configuracionFinalizada = false;
          }
        }
      })
    }
  }

  ngOnDestroy(): void {
    if (this.establishmentSubscription) {
      this.establishmentSubscription.unsubscribe();
    } 
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
    if (this.editarDispositivoSubscription) {
      this.editarDispositivoSubscription.unsubscribe();
    }
  }

  initMap(){
    const mapElement = document.getElementById('map');
    // Verificar si el elemento existe antes de intentar trabajar con él
    if (mapElement) {
      const mapOptions = {
        center: { lat: this.lat, lng: this.lng },
        zoom: this.zoom,
      };
      this.map = new google.maps.Map(mapElement, mapOptions);
      this.marker = new google.maps.Marker({
        position: { lat: this.lat, lng: this.lng },
        map: this.map,
        draggable: false,
        title: 'Marcador'
      });
    } else {
      console.error('Elemento del mapa no encontrado en el DOM.');
    }
    this.getAddress(this.lat, this.lng);
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  getAddress(latitude: number, longitude: number) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: {lat: latitude, lng: longitude} }).then((response) => {
      //la posicion 0 es el lugar más cercano al click
      if(response.results[0]) {
        this.addressData = response.results[0].formatted_address;
        this.cdr.detectChanges();
      } else{
        window.alert("No hay resultados");
      }
    })
  }

  onFileSelected(event: any) {
    this.file = event.target.files[0];
    console.log(this.file);
    if (this.file && this.file.type === 'image/jpeg') {
      this.previewImage();
      console.log('Archivo seleccionado:', this.file.name);
      this.showImageErrorMessage = false;
    } else {
      this.imageUrl = null;
      this.showImageErrorMessage = true;
      console.log('Por favor, seleccione un archivo .jpg');
    }
    if(this.file == undefined){
      this.showImageErrorMessage = false;
    }
  }

  previewImage() {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = reader.result;
    };
    reader.readAsDataURL(this.file as Blob);
  }

  //Función para devolver 1 si el valor es true y 0 si es false
  booleanToNumber(value: boolean): number {
    return value ? 1 : 0;
  }

}
